import { useQuery } from "@tanstack/react-query"
import { getSubscriptionMember } from "../services"
import type { TSubscriptionMember } from "../types"

export const subscriptionMemberKeys = {
  all: (workspaceId: string) => ["subscription-member", workspaceId] as const,
}

const DEV_MOCK = false

export function useGetSubscriptionMember(
  workspaceId: string,
  options?: { enabled?: boolean },
) {
  if (DEV_MOCK) {
    console.warn("[useGetSubscriptionMember stub]")
    return { data: null, isLoading: false, isError: false, refetch: () => Promise.resolve() }
  }

  return useQuery<TSubscriptionMember>({
    queryKey: subscriptionMemberKeys.all(workspaceId),
    queryFn: ({ signal }) => getSubscriptionMember(workspaceId, signal),
    enabled: options?.enabled ?? !!workspaceId,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  })
}
